import { render, staticRenderFns } from "./product.view.vue?vue&type=template&id=1efb0f17&"
import script from "./product.view.vue?vue&type=script&lang=js&"
export * from "./product.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports